// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b3b083ea60df479363ed","655":"ec3a8809a7f84c4e30e3"}[chunkId] + ".js";
};